"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
var _interopRequireWildcard = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireWildcard.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/OutputTable/Search/DateDay.js";
function DateDay(_ref) {
  var field = _ref.field,
    onChange = _ref.onChange;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  function _onChange(startDate) {
    setValue(startDate.toISOString().slice(0, 10));
    startDate.setHours(0, 0, 0, 0);
    var endDate = new Date();
    endDate.setDate(startDate.getDate());
    endDate.setHours(23, 59, 59, 999);
    var where = {};
    where[field] = {
      $gte: startDate.toISOString(),
      $lte: endDate.toISOString()
    };
    onChange(where);
  }
  _react["default"].useEffect(function () {
    _onChange(new Date());
  }, []);
  return /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-control form-control-sm shadow-none w-auto rounded-0 rounded-end",
    value: value,
    onInput: function onInput(e) {
      return _onChange(e.target.valueAsDate);
    },
    type: "date",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 9
    }
  });
}
var _default = DateDay;
exports["default"] = _default;